"use client";

import { useEffect, useRef } from "react";
import { type GtmItem, trackViewItem } from "@/lib/gtm";

/**
 * Fires GA4 `view_item` once when the PDP mounts. The item is built server-side
 * in ProductDetailsPage where all Centra fields are in scope, so this only needs
 * to push it. Guarded by a ref keyed on `item_id` so Strict-Mode double-renders
 * don't double-fire; a variant switch navigates to a new slug (fresh mount) and
 * re-fires, which is the intended behaviour.
 */
export const GtmViewItem = ({
	item,
	currency,
	value,
}: {
	item: GtmItem;
	currency?: string;
	value?: number;
}) => {
	const firedFor = useRef<string | undefined>(undefined);

	useEffect(() => {
		if (!item.item_id || firedFor.current === item.item_id) return;
		firedFor.current = item.item_id;
		trackViewItem({ currency, value, items: [item] });
	}, [item, currency, value]);

	return null;
};
